export const required = (value) => (value) ? undefined : 'Required';
export const phoneNumber = (value) => !value || value.replace(/\s/, '').match(/^[89]\d{7}$/) ? undefined : 'Please enter a valid phone number';
export const email = (value) => {
  return (!value || value.match(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/)) ? undefined : 'Please enter a valid email';
};

export const passwordRegex = /^(?=.*\d).{6,}$/;
export const passwordInstructions = 'Password must be at least 6 characters and include at least one number';

export const password = (value) => {
  return (!value || value.match(passwordRegex) ? undefined: passwordInstructions);
};


// WEBPACK FOOTER //
// ./src/validators.js